export const data = [
  {
    id: 1,
    name: '西施'
  },
  {
    id: 2,
    name: '范冰冰'
  },
  {
    id: 3,
    name: '李冰冰'
  },
  {
    id: 4,
    name: '高园园'
  },
  {
    id: 5,
    name: '陈好'
  },
  {
    id: 6,
    name: 'angelababy'
  },
  {
    id: 7,
    name: '迪丽热巴'
  },
  {
    id: 8,
    name: '周杰伦'
  },
  {
    id: 9,
    name: '刘德华'
  },
  {
    id: 10,
    name: '张学友'
  }
];
